const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

const fallbackBackendUrl = (() => {
  if (typeof window === 'undefined') {
    return '';
  }

  const { hostname, port } = window.location;

  if (hostname.endsWith('.preview.emergentagent.com')) {
    return 'https://realty.livelongwealth.in';
  }

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    if (port === '3000') {
      return configuredBackendUrl || 'http://127.0.0.1:8001';
    }

    return '';
  }

  return '';
})();

export const API_BASE_URL = (fallbackBackendUrl || configuredBackendUrl || '').replace(/\/$/, '');

export const buildApiUrl = (path) => `${API_BASE_URL}${path}`;
